exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */:host{position:relative;width:100%;height:100%;background:#eee}canvas{display:block;width:100%;height:100%}.m-scroll-container{overflow:scroll;width:100%;height:100%}.m-canvas{position:absolute;top:0;left:0}", ""]);

// exports
